export default function CAEditCustomerLogoDirectiveController(
  $q,
  $rootScope,
  $scope,
  alerts,
  confirmDialog,
  orgDataService,
  ssDialogService,
  userService,
  editBankLogoDialog
) {
  const vm = this;

  vm.canEditLogo = true;
  vm.imgByteArray = null;
  vm.hasLogo = false;

  vm.handleSetBankLogoClick = _handleSetBankLogoClick;
  vm.handleDeleteCustomerLogoClick = _handleDeleteCustomerLogoClick;

  _initEventListeners();

  function _initEventListeners() {
    $scope.$on('refreshCustomer', (event, opt) => {
      if (opt.customerId === vm.customer.customerId) {
        _refresh().then(() => {
          $scope.$emit(`Customer logo ${vm.customer.customerId}refreshed`);
        });
      }
    });
  }

  function _refresh() {
    const dfdRefresh = $q.defer();

    vm.canEditLogo = userService.getUserPermission('displayBankAdminUploadLogo');

    if (vm.customer.logoDocumentId > 0) {
      orgDataService.downloadDocumentContent(vm.customer.logoDocumentId, vm.customer.customerId)
        .then((downloadLogoResponse) => {
          vm.imgByteArray = downloadLogoResponse.data.result;
          vm.hasLogo = true;
        });
    } else {
      vm.hasLogo = false;
    }
    return dfdRefresh.promise;
  }

  function _handleSetBankLogoClick($event) {
    ssDialogService.dialogs.admin.editCustomerLogoDialog = ssDialogService.alert(
      editBankLogoDialog.getOptions($event, {
        customerId: vm.customer.customerId,
      })
    );
    ssDialogService.show(ssDialogService.dialogs.admin.editCustomerLogoDialog);
  }

  function _handleDeleteCustomerLogoClick($event) {
    ssDialogService.dialogs.admin.confirmDeleteCustomerLogoDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Delete Customer Logo?',
        message: 'Are you sure you want to delete the customer logo?',
        handleYesClick: _handleConfirmDeleteClick,
        handleNoClick: _handleCancelDeleteClick,
      })
    );

    ssDialogService.show(ssDialogService.dialogs.admin.confirmDeleteCustomerLogoDialog);
  }

  function _handleConfirmDeleteClick() {
    return orgDataService.deleteCustomerLogo(vm.customer.customerId)
      .then(() => {
        alerts.success('The Logo has been deleted successfully.');
        $rootScope.$broadcast('refreshCustomer', { customerId: vm.customer.customerId });
        _closeDeleteDialog();
      }).catch(() => {
        alerts.error('An error occurred while deleting the Logo.');
      });
  }

  function _handleCancelDeleteClick() {
    _closeDeleteDialog();
  }

  function _closeDeleteDialog() {
    ssDialogService.hide(ssDialogService.dialogs.admin.confirmDeleteCustomerLogoDialog);
  }
}

CAEditCustomerLogoDirectiveController.$inject = [
  '$q',
  '$rootScope',
  '$scope',

  'alerts',
  'confirmDialog',
  'orgDataService',
  'ssDialogService',
  'userService',

  'editBankLogoDialog'
];
